export default "__VITE_ASSET__DzqS66iC__"